import * as React from 'react'

import * as Card from '../Card'
import * as Indicators from '../Indicators'
import * as Modal from './Modal'

export interface IViewProps {
  onDismiss: () => void
  loading?: boolean
  disabled?: boolean
  size?: Modal.Size
}

export const View: React.FunctionComponent<React.PropsWithChildren<
  IViewProps
>> = ({ children, loading, onDismiss, disabled, size = Modal.Size.small }) => {
  const handleClick: React.MouseEventHandler = (e) => e.stopPropagation()
  return (
    <Modal.Container onClick={onDismiss} transparent={true} disabled={disabled} loading={loading}>
      <Modal.ContentRegion size={size} onClick={handleClick as any}>
        <Card.View>
          {loading ? (
            <div className="m-auto p-4">
              <Indicators.Spinner size="4x" />
            </div>
          ) : (
            children
          )}
        </Card.View>
      </Modal.ContentRegion>
    </Modal.Container>
  )
}
